/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Table_Header_LocationInputs */

const en_privacy_table_header_location = /** @type {(inputs: Privacy_Table_Header_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Location`)
};

const de_privacy_table_header_location = /** @type {(inputs: Privacy_Table_Header_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standort`)
};

const fr_privacy_table_header_location = /** @type {(inputs: Privacy_Table_Header_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Localisation`)
};

const es_privacy_table_header_location = /** @type {(inputs: Privacy_Table_Header_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ubicación`)
};

const it_privacy_table_header_location = /** @type {(inputs: Privacy_Table_Header_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ubicazione`)
};

const nl_privacy_table_header_location = /** @type {(inputs: Privacy_Table_Header_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Locatie`)
};

const pl_privacy_table_header_location = /** @type {(inputs: Privacy_Table_Header_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lokalizacja`)
};

const fi_privacy_table_header_location = /** @type {(inputs: Privacy_Table_Header_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sijainti`)
};

const da_privacy_table_header_location = /** @type {(inputs: Privacy_Table_Header_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lokation`)
};

const sv_privacy_table_header_location = /** @type {(inputs: Privacy_Table_Header_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plats`)
};

/**
* | output |
* | --- |
* | "Location" |
*
* @param {Privacy_Table_Header_LocationInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_table_header_location = /** @type {((inputs?: Privacy_Table_Header_LocationInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Table_Header_LocationInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_table_header_location(inputs)
	if (locale === "fr") return fr_privacy_table_header_location(inputs)
	if (locale === "es") return es_privacy_table_header_location(inputs)
	if (locale === "it") return it_privacy_table_header_location(inputs)
	if (locale === "nl") return nl_privacy_table_header_location(inputs)
	if (locale === "pl") return pl_privacy_table_header_location(inputs)
	if (locale === "fi") return fi_privacy_table_header_location(inputs)
	if (locale === "da") return da_privacy_table_header_location(inputs)
	if (locale === "sv") return sv_privacy_table_header_location(inputs)
	return en_privacy_table_header_location(inputs)
});